import {makeAutoObservable} from 'mobx';
import store from '../../../../s';
import {modal} from '../../../../../util';
import {checkout} from '../../../../../api';

class ButtonMultilineShipmentsStore {
    public expandedIndexes: number[] = [];

    constructor() {
        makeAutoObservable(this);
    }

    address = (i: IAddress) => {
        const fields = ['address1', 'city', 'state', 'postalCode', 'country'];
        const populated = Object.keys(i).length !== 0 && fields.every(field => i[field]?.value);

        if (populated) {
            return fields.map(field => i[field]?.value).join(', ');
        } else {
            return 'Empty';
        }
    };

    collapseForm = (index: number) => {
        this.expandedIndexes = this.expandedIndexes.filter(i => i !== index);
    };

    expandForm = (index: number) => {
        this.expandedIndexes.push(index);
    };

    expandAll = (cartItem: ICartLineItem) => {
        this.expandedIndexes = new Array(cartItem.address.length).fill(0).map((_, i) => i);
    };

    collapseAll = () => {
        this.expandedIndexes = [];
    };

    clearAddress = (cartItem: ICartLineItem, index: number) => {
        cartItem.address[index] = store.getEmptyAddr(true);
        this.collapseForm(index);
    };

    clearAllAddresses = (cartItem: ICartLineItem) => {
        this.getAddressLines(cartItem, true);
        this.collapseAll();
    };

    getAddressLines = async (cartItem: ICartLineItem, forceClear: boolean = false) => {
        const existing = Array.isArray(cartItem.address) ? [...cartItem.address] : [];
        const qty = cartItem.qty;
        const emptyAddrFactory = () => store.getEmptyAddr(true);

        let targetAddress: IAddress[];

        if (forceClear) {
            targetAddress = Array.from({length: qty}, emptyAddrFactory);
        } else {
            const missingCount = qty - existing.length;

            if (missingCount > 0) {
                targetAddress = existing.concat(Array.from({length: missingCount}, emptyAddrFactory));
            } else {
                targetAddress = existing.slice(0, qty);
            }
        }

        const same = JSON.stringify(cartItem.address ?? []) === JSON.stringify(targetAddress);

        if (!same) {
            cartItem.address = targetAddress;

            try {
                await this.saveAddress();
            } catch (err) {
                console.error('Failed to save address', err);
            }
        }
    };

    openModal = (id: number) => {
        this.collapseAll();
        modal(`modal-multiline-shipments-${id}`);
    };

    formInvalid = (address: IAddress) => {
        return Object.values(address).some((i: IFormInput) => {
            if (typeof i === 'object') {
                return i.valid.isError;
            }
        });
    };

    saveButtonDisabled = (address: IAddress[]) => {
        if (!address) {
            return;
        }

        return address.some(i => this.formInvalid(i));
    };

    saveAddress = async () => {
        await checkout('update-multiline-shipments');
    };
}

export const buttonMultilineShipmentsStore = new ButtonMultilineShipmentsStore();
